export const storageAccountName = process.env.REACT_APP_storageAccountName;
export const blob_azure_container = process.env.REACT_APP_blob_azure_container;
export const sasToken = process.env.REACT_APP_sasToken;
export const AZURE_IMAGE_URL = `https://${storageAccountName}.blob.core.windows.net/${blob_azure_container}`;
export const AZURE_IMAGE_URL_CROPED = `https://${storageAccountName}.blob.core.windows.net/${blob_azure_container}croped`;
// Guidlines
export const blob_azure_container_guidlines = process.env.REACT_APP_blob_azure_container_guidlines;
export const AZURE_GUIDLINES_IMAGE_URL = `https://${storageAccountName}.blob.core.windows.net/${blob_azure_container_guidlines}`;
